// imports
import Map from './lib/map';
import Links from './lib/links';
import Regex from './lib/regex';
import Texts from './lib/texts';
import Routes from './lib/routes';
import Traits from './lib/traits.json';

// exports
export const MAP = Map;
export const LINKS = Links;
export const REGEX = Regex;
export const TEXTS = Texts;
export const ROUTES = Routes;
export const TRAITS = Traits as { [key: string]: unknown };

export default {
  MAP, ROUTES, REGEX, LINKS, TEXTS, TRAITS
} as const;
